export default {
  methods: {
    async tryCall(call, errorMessage = null) {
      try {
        const result = await call()
        return {
          success: true,
          data: result,
        }
      } catch (e) {
        this.$logError(e)
        errorMessage !== null ? this.$notifyError(errorMessage) : null
        return {
          success: false,
          error: e,
        }
      }
    },
    async tryGet(url, errorMessage = null) {
      return await this.tryCall(() => this.$apiClient.get(url), errorMessage)
    },
  },
}
